import {Editor} from "../../../../../../pkg/slate.js";
export const isStart = (editor, point, at) => !!point && Editor.isStart(editor, point, at);
